export const NexusHome = () => {
    return (
        <>
            Nexus Home
        </>
    )
}